import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Check } from 'lucide-react';

const SuccessPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  return (
    <div className="min-h-screen bg-gradient-to-b from-black to-[#1a1a1a] flex items-center justify-center px-6">
      <div className="max-w-2xl w-full text-center">
        <div className="bg-[#68caf1] rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-8 shadow-lg shadow-[#68caf1]/30">
          <Check className="w-10 h-10 text-black" />
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
          Welcome to the Monarch Family!
        </h1>
        <p className="text-lg text-gray-400 mb-8 leading-relaxed">
          Your $50 deposit has been received and your spot is officially secured.
          Check your email for a confirmation with your schedule details.
        </p>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 mb-8 text-left">
          <h3 className="text-[#68caf1] font-bold text-lg mb-4">What Happens Next</h3>
          <ol className="text-gray-300 space-y-3 list-decimal list-inside">
            <li>We'll contact you within 48 hours to confirm your schedule</li>
            <li>Your Alchemist Deep Clean will be scheduled (starting April 1st)</li>
            <li>Monthly maintenance begins after your Deep Clean is complete</li>
          </ol>
        </div>

        <Link
          to="/"
          className="inline-block bg-[#68caf1] text-black px-8 py-3 rounded-lg font-bold hover:bg-[#5bb8db] transition-all"
        >
          Back to Home
        </Link>

        {sessionId && (
          <p className="text-xs text-gray-600 mt-6">
            Reference: {sessionId}
          </p>
        )}
      </div>
    </div>
  );
};

export default SuccessPage;
